<template>
  <Layout>
    <SubHeader slot="sub-header" 
      :title="$t('course.title')"
      :isBackground="false" />

    <div slot="body" class="video-course-view">
      <LoadingBounce v-if="busy" class="w-100" />
      <template v-else>
        <div class="row">
          <div class="col-lg-12 px-12 mt-6 px-6">
            <CourseCard :course="videoCourse" 
              :isCardList="true"
              :isVideoCourse="true" />
          </div>
        </div>

        <div class="course-description">
          {{ videoCourseDescription }}
        </div>

        <div class="course-created-date">
          {{ $t('common.created_date')}} {{ videoCourseCreatedDate }}
        </div>

        <div v-if="videoCourseLectures.length > 0" class="course-lectures">
          <div class="row align-items-center header">
            <div class="col-8 title px-0">{{ $t('course.video_lecture') }} {{ videoLectureCount }}</div>
            <div class="col-4 action px-0">{{ $t('course.video_lecture_time') }} {{ videoCourseDuration }}</div>
          </div>

          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6 col-6 px-6" 
              v-for="(item, index) in videoCourseLectures" :key="index">
              <VideoCard :videoLecture="item"
                :eventLabel="'video_course.lecture'"
                :isCourseCard="true"
                :courseId="courseId" />
            </div>

            <InfiniteLoading v-if="videoCourseLectures.length >= 10" @infinite="infiniteHandler" class="w-100">
              <div slot="spinner">
                <LoadingBounce></LoadingBounce>
              </div>
              <span slot="no-results"></span>
              <span slot="no-more"></span>
            </InfiniteLoading>

          </div>
        </div>
      </template>
    </div>
  </Layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import moment from 'moment/src/moment';
  import { isEmpty } from 'lodash';
  import InfiniteLoading from 'vue-infinite-loading';

  export default {
    name: 'video-course-view',

    data() {
      return {
        page: 1,
        limit: 10,
        videoCourse: {},
        videoCourseLectures: [],
        busy: false,
      };
    },

    components: {
      InfiniteLoading,
    },

    computed: {
      ...mapGetters({
        routerParams: 'getRouteParams',
        subjects: 'getSubjectMap',
      }),

      videoLectureCount() {
        return this.videoCourse && this.videoCourse.lecture_count;
      },

      videoCourseCreatedDate() {
        return moment(this.videoLecture && this.videoLecture.created_at).format('YYYY.MM.DD');
      },

      videoCourseDescription() {
        return this.videoCourse && this.videoCourse.description;
      },

      videoCourseDuration() {
        return moment.utc(this.videoCourse && this.videoCourse.duration * 1000).format('HH:mm:ss');
      },

      courseId() {
        return Number(this.routerParams.courseId) || 0;
      },
    },

    methods: {
      ...mapActions([
        'fetchSubjects',
        'fetchVideoCourse',
        'fetchVideoCoursesLectures',
      ]),

      infiniteHandler($state) {
        this.page += 1;
        const filters = {
          video_course_id: this.courseId,
          page: this.page,
          per_page: this.limit,
          order_by: 'position',
        };

        this.fetchVideoCoursesLectures(filters)
          .then((data) => {
            if (data.length > 0) {
              this.videoCourseLectures = this.videoCourseLectures.concat(data);
              return $state.loaded();
            }
            return $state.complete();
          });
      },
    },

    beforeMount() {
      this.busy = true;
      Promise.resolve()
        .then(() => {
          if (isEmpty(this.subjects)) {
            return this.fetchSubjects();
          }
          return true;
        })
        .then(() => this.fetchVideoCourse(this.courseId))
        .then((videoCourse) => {
          this.videoCourse = videoCourse;
          return videoCourse;
        })
        .then((videoCourse) => {
          const filters = {
            video_course_id: videoCourse.id,
            order_by: 'position',
          };
          this.fetchVideoCoursesLectures(filters)
            .then((videoCourseLectures) => {
              this.videoCourseLectures = videoCourseLectures;
              return true;
            });
        })
        .then(() => {
          this.busy = false;
        });
    },

  };
</script>

<style lang="scss" scoped>
  .video-course-view {
    max-width: 946px;
    margin: 0 auto;
    padding: 0px 14px 0px 14px;

    .course-description {
      padding: 24px 0px 24px 0px;
      color: rgba(0, 0, 0, 0.54);
      word-break: break-all;
    }

    .course-created-date {
      padding-bottom: 64px;
      text-align: right;
      color: rgba(0, 0, 0, 0.54);
    }

    .course-lectures {
      .header {
        padding: 20px 14px 20px 14px;

        .title {
          font-size: 18px;
        }

        .action {
          text-align: right;
          color: rgba(0, 0, 0, 0.54);
        }
      }
    }

  }
</style>


// WEBPACK FOOTER //
// VideoCourseView.vue?86e7c2b0